var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#E8751E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 53.3333H13.3333C11.5 53.3333 10 51.8333 10 50V16.6667C10 14.8333 11.5 13.3333 13.3333 13.3333H66.6667C68.5 13.3333 70 14.8333 70 16.6667V50C70 51.8333 68.5 53.3333 66.6667 53.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 53.3333H13.3333C11.5 53.3333 10 51.8333 10 50V43.3333H70V50C70 51.8333 68.5 53.3333 66.6667 53.3333Z",
    fill: "#E8751E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9997 68.3334H34.9997C33.9997 68.3334 33.333 67.6667 33.333 66.6667V53.3334C33.333 52.3334 33.9997 51.6667 34.9997 51.6667H44.9997C45.9997 51.6667 46.6663 52.3334 46.6663 53.3334V66.6667C46.6663 67.6667 45.9997 68.3334 44.9997 68.3334ZM36.6663 65H43.333V55H36.6663V65Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53.3333H35V66.6666H45V53.3333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 50C40.9201 50 41.6663 49.2538 41.6663 48.3334C41.6663 47.4129 40.9201 46.6667 39.9997 46.6667C39.0792 46.6667 38.333 47.4129 38.333 48.3334C38.333 49.2538 39.0792 50 39.9997 50Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6663 11.6667H13.333C10.4997 11.6667 8.33301 13.8333 8.33301 16.6667V50C8.33301 52.8333 10.4997 55 13.333 55H33.333V65H24.1663C23.1663 65 22.4997 65.6667 22.4997 66.6667C22.4997 67.6667 23.1663 68.3333 24.1663 68.3333H33.333H46.6663H55.833C56.833 68.3333 57.4997 67.6667 57.4997 66.6667C57.4997 65.6667 56.833 65 55.833 65H46.6663V55H66.6663C69.4997 55 71.6663 52.8333 71.6663 50V16.6667C71.6663 13.8333 69.4997 11.6667 66.6663 11.6667ZM11.6663 16.6667C11.6663 15.6667 12.333 15 13.333 15H66.6663C67.6663 15 68.333 15.6667 68.333 16.6667V41.6667H11.6663V16.6667ZM43.333 65H36.6663V55H43.333V65ZM68.333 50C68.333 51 67.6663 51.6667 66.6663 51.6667H46.6663H33.333H13.333C12.333 51.6667 11.6663 51 11.6663 50V45H68.333V50Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.67192471f9c5542b11724d48d26f41bd.svg";
export { ForwardRef as ReactComponent };